export default __webpack_public_path__ + "static/maple-5300fd5a2dff427b4b01f9a01694bf12.png";